import React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { InputAdornment, Input, FormControl, InputLabel } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Filter } from '@carbon/icons-react';
import { isMobile } from 'react-device-detect';

import useStore from '../../store/useStore';

const SearchBarMySessions = () => {
  const {
    startdatesession,
    darkTheme,
    setFilter,
    filters: { searchSession }
  } = useStore((state: any) => ({
    startdatesession: state.settings.params.startdatesession,
    darkTheme: state.settings.params.darkTheme,
    setFilter: state.setFilter,
    filters: state.filters
  }));

  const [dateValue, setDateValue] = React.useState<Dayjs | null>(dayjs());

  const divStyleDark = {
    width: '100%',
    padding: '1.5rem 0 1rem 0',
    backgroundColor: '#293336',
    margin: '0px',
    paddingRight: '10px'
  };
  const divStyleLight = {
    width: '100%',
    padding: '1.5rem 0 1rem 0',
    margin: '0px',
    paddingRight: '10px'
  };

  const formSearchInputStyleDark = { backgroundColor: '#182124', borderRadius: '4px' };
  const formSearchInputStyleLight = { borderRadius: '4px' };

  const inputSearchStyleDark = { fontSize: '1rem', color: '#fff', margin: '0px', height: '50px' };
  const inputSearchStyleLight = { fontSize: '1rem', margin: '0px', height: '50px' };

  const inputSearchIconStyleDark = { margin: '0 1rem', color: '#fff' };
  const inputSearchIconStyleLight = { margin: '0 1rem' };

  const formDateInputStyleDark = { backgroundColor: '#182124', borderRadius: '4px' };
  const formDateInputStyleLight = { borderRadius: '4px' };

  const datePickerSlotStyleDark = {
    backgroundColor: '#182124',
    '.MuiPickersCalendarHeader-root': {
      color: 'white'
    },
    '.MuiPickersDay-root': {
      color: 'white'
    },
    '.MuiDayCalendar-weekDayLabel': {
      color: 'white'
    }

    /*opacity: 0.5*/
  };

  const datePickerSlotStyleLight = {};

  const inputDatePickerStyleDark = { color: 'white' };
  const inputDatePickerStyleLight = {
    color: '#6E6E6E',

    '&.Mui-focused .MuiInputLabel-root': {
      /*color: 'blue',*/
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#6E6E6E'
    },
    '&.Mui-focused .MuiSvgIcon-root': {
      /*color: 'blue',*/
    }
  };

  const selectIconLight = {
    '& .MuiSvgIcon-root': {
      color: '#6E6E6E'
    }
  };
  const selectIconDark = {
    '& .MuiSvgIcon-root': {
      color: 'white'
    }
  };

  let tabLabelStyle = document.createElement('style');
  tabLabelStyle.type = 'text/css';
  tabLabelStyle.innerHTML = '.tabLabelStyle{ font-weight:bold; font-size: large;}';
  document.getElementsByTagName('head')[0].appendChild(tabLabelStyle);

  let marginLeft = '60%';
  if (isMobile) marginLeft = '0%';
  const toggleFiltersStyleDark = {
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginLeft: marginLeft
  };
  const toggleFiltersStyleLight = {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginLeft: marginLeft
  };

  const handleChangeDate = (dateValue: any) => {
    console.log(dateValue, typeof dateValue);
    //set filter value and rebuild data
    let newDate = '';
    if (dateValue !== null) newDate = dayjs(dateValue.$d).format('DD/MM/YYYY');

    //console.log(newDate.length);

    setFilter('DateSession', newDate);
    setDateValue(dayjs(dateValue.$d));
    //console.log('newdate value ' + dateValue)
  };

  const toggleFilters = () => {
    const targetDiv = document.getElementById('FilterBarSessions');
    const btn = document.getElementById('toggleFiltersButton');

    if (targetDiv!.style.display !== 'none') {
      targetDiv!.style.display = 'none';
      btn!.style.fontWeight = 'bold';
      btn!.style.color = '#2f2f2f';
      //btn!.style.color = "white";
    } else {
      targetDiv!.style.display = 'block';
      btn!.style.fontWeight = 'normal';
      btn!.style.color = '#007FAD';
    }
  };

  const setDivStyle = (darkTheme: any) => {
    if (darkTheme === '1') {
      return divStyleDark;
    } else {
      //define the arrow css style
      let Arrowstyle = document.createElement('style');
      Arrowstyle.type = 'text/css';
      Arrowstyle.innerHTML = '.MuiPickersArrowSwitcher-button{ color: gray !important;}';
      document.getElementsByTagName('head')[0].appendChild(Arrowstyle);

      return divStyleLight;
    }
  };

  const [tabValue, setTabValue] = React.useState(0);

  const setNewTab = (event: React.SyntheticEvent, newValue: number) => {
    setFilter('MySessions', newValue);

    setTabValue(newValue);
  };

  return (
    <div style={setDivStyle(darkTheme)}>
      <div className="ituContainer grid">
        <div data-span="6">
          <Tabs value={tabValue} onChange={setNewTab} aria-label="basic tabs example">
            <Tab disableRipple label={<span className="tabLabelStyle">All Sessions</span>} />
            <Tab disableRipple label={<span className="tabLabelStyle">My Sessions</span>} />
          </Tabs>
        </div>
        <div data-span="3">
          <FormControl
            variant="standard"
            fullWidth
            style={darkTheme === '1' ? formSearchInputStyleDark : formSearchInputStyleLight}>
            <InputLabel htmlFor="search"></InputLabel>
            <Input
              id="searchSession"
              style={darkTheme === '1' ? inputSearchStyleDark : inputSearchStyleLight}
              placeholder="Search"
              value={searchSession}
              onChange={(e) => setFilter('searchSession', e.target.value)}
              startAdornment={
                <InputAdornment position="start">
                  <FontAwesomeIcon
                    icon={faSearch}
                    style={darkTheme === '1' ? inputSearchIconStyleDark : inputSearchIconStyleLight}
                  />
                </InputAdornment>
              }
            />
          </FormControl>
        </div>

        {/* Date filter */}
        <div
          data-span="3"
          style={{
            display: 'flex'
          }}>
          <div style={{ width: '60%' }}>
            <FormControl
              variant="standard"
              id={darkTheme === '1' ? 'filterApp' : 'noFilterApp'}
              style={darkTheme === '1' ? formDateInputStyleDark : formDateInputStyleLight}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={dateValue}
                  onChange={(newValue) => {
                    handleChangeDate(newValue);
                  }}
                  slotProps={{
                    layout: {
                      sx: darkTheme === '1' ? datePickerSlotStyleDark : datePickerSlotStyleLight
                    },
                    textField: {
                      required: false,
                      error: false,
                      InputProps: {
                        sx: darkTheme === '1' ? inputDatePickerStyleDark : inputDatePickerStyleLight
                      }
                    }
                  }}
                  sx={darkTheme === '1' ? selectIconDark : selectIconLight}
                  format="DD/MM/YYYY"
                />
              </LocalizationProvider>
            </FormControl>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'center',
              verticalAlign: 'middle',
              fontWeight: 'bold',
              textAlign: 'center',
              alignItems: 'center'
            }}>
            <div
              id="toggleFiltersButton"
              style={darkTheme === '1' ? toggleFiltersStyleDark : toggleFiltersStyleLight}
              onClick={toggleFilters}>
              <Filter style={{ marginRight: '5px' }} />
              Filters
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SearchBarMySessions;
